<div class="associations-container dark-mode">
    <div class="page-header mt-5">
        <div class="d-flex">
            <mat-icon class="back-button" (click)="goBack()">chevron_left</mat-icon>
            <h1 class="page-title">Support Inbox</h1>
        </div>
        <div class="breadcrumb">
            <span class="breadcrumb-item">Dashboard</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item" (click)="goBack()">Inbox</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-current">{{ticket?.fullName }} - {{ticket?.email }}</span>
        </div>
    </div>

    <hr class="mb-4" />

        <div class="chat-container mb-5" style="height: 70vh">

            <div class="chat-header">
                <span class="chat-title">#{{ ticket.id }} - {{ticket.messageSubject}}</span>
                <span class="chat-status-closed" *ngIf="ticket && ticket.status && ticket.status == 'CLOSED'">{{ ui.capitalizeFirstLetter(ticket.status) }}</span>
                <span class="chat-status" *ngIf="ticket && ticket.status && ticket.status == 'OPEN'">{{ ui.capitalizeFirstLetter(ticket.status) }}</span>
            </div>

            <div class="chat-body"  #scrollContainer>
                <ng-container *ngFor="let d of ticket.walletSupportDetails">
                    <ng-container *ngIf="d.createdBy != user.email">
                        <div class="chat-message received">
                            <p [innerText]="ui.decodeHtmlEntities(d.message)"></p>
                            <p *ngIf="d.walletSupportAttachment">
                            <span (click)="downloadAttachment(d.walletSupportAttachment.id, d.walletSupportAttachment.fileAttachment)" class="attachment">
                                <mat-icon>attachment</mat-icon> Download attachment
                            </span>
                            </p>
                        </div>
                        <span class="received-time">{{ d.createdAt | date : "MM/dd/y hh:mm:ss" }}</span>
                    </ng-container>

                    <ng-container *ngIf="d.createdBy == user.email">
                        <div class="chat-message sent">
                            <p [innerText]="ui.decodeHtmlEntities(d.message)"></p>
                            <p *ngIf="d.walletSupportAttachment">
                            <span (click)="downloadAttachment(d.walletSupportAttachment.id, d.walletSupportAttachment.fileAttachment)" class="attachment">
                                <mat-icon>attachment</mat-icon> Download attachment
                            </span>
                            </p>
                        </div>
                        <span class="sent-time">{{ d.createdAt | date : "MM/dd/y hh:mm:ss" }}</span>
                    </ng-container>
                </ng-container>
                <span *ngIf="ticket.status && ticket.status == 'CLOSED'" class="closed-ticket-notification">This ticket has been closed</span>

            </div>

            <form [formGroup]="form" >
                <div class="chat-footer">
                    <button *ngIf="ticket.status && ticket.status == 'OPEN'" (click)="closeTicket()" type="button" class="my-3 w-100" style="border: 1px solid #ccc" mat-flat-button>Close Ticket</button>
                </div>
                <div class="chat-footer">

                    <mat-form-field class="full-width w-100" appearance="outline">
                    <textarea
                            matInput
                            formControlName="message"
                            placeholder="Type here..."
                            cdkTextareaAutosize
                            cdkAutosizeMinRows="1"
                            cdkAutosizeMaxRows="5">
                    </textarea>

                        <button class="d-none d-sm-none d-md-none d-lg-inline" (click)="hasAttachment = !hasAttachment" type="button" mat-icon-button matSuffix>
                            <mat-icon>attachment</mat-icon>
                        </button>
                        <button type="button" class="send-button d-none d-sm-none d-md-none d-lg-inline" mat-icon-button matSuffix (click)="sendMessage()">
                            <mat-icon>send</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
                <div class="chat-footer d-block d-sm-block d-md-block d-lg-none">
                    <button class="w-100" color="primary" (click)="hasAttachment = !hasAttachment" type="button" mat-raised-button matSuffix>
                        <mat-icon>attachment</mat-icon> Add Attachment
                    </button>
                    <button type="button" class="w-100 mt-2 brand-cw-color" mat-raised-button matSuffix (click)="sendMessage()">
                        <mat-icon>send</mat-icon> Send Message
                    </button>
                </div>
                <div class="chat-footer" *ngIf="hasAttachment">
                    <app-upload-single style="width: 100%"
                                       (fileChange)="getFileChange($event)"
                                       [accept]="'image/*,application/pdf'"
                                       [fileUrl]="fileUrl"
                                       [labelButton]="'Browse File'"
                                       [label]="'Accepted File Type Image or PDF'"
                                       [readonly]="uploading"
                                       [theme]="'dark'"
                    >

                    </app-upload-single>
                </div>
            </form>
        </div>
</div>


